import { gql } from '@apollo/client'

export const GET_VISIBLE_BIDS = gql`
  query GetVisibleBids($fantasyLeagueId: ID!) {
    visibleBids(fantasyLeagueId: $fantasyLeagueId) {
      id
      createdAt
      amount
      status
      marketEntry {
        id
        player {
          id
          createdAt
          nick
          name
          lastName
          role
          marketValue
          image
          totalScore
          lastWeekScore
          lastWeekNumber
          team {
            id
            competition {
              id
              code
              displayName
              rank
            }
            createdAt
            nameShow
            shortName
            shield
          }
        }
        seller {
          id
          teamName
        }
      }
      bidder {
        id
        teamName
      }
    }
  }
`
